import EyeIcon from "ps-react/EyeIcon";

function ExampleEyeIcon() {
    return <EyeIcon />
}

export default ExampleEyeIcon;